import { inject } from "mobx-react";
import React from "react";
import { Route, RouteComponentProps, Switch, useHistory } from "react-router";
import { DEFAULT_SERVICE_PROFILE, ServiceProfileSchema } from "./schema";
import {
  CreateView,
  DynamicColumn,
  IndexView,
  ShowView,
  withBreadCrumbs
} from "lego-gui-lib/lib";
import i18next from "i18next";
import { observer } from "mobx-react-lite";

export const ServiceProfiles = {
  url: "/serviceProfiles",
  handler: (props: RouteComponentProps<any>) => {
    const baseUrl = props.match.url;
    const title = i18next.t("hns:serviceProfile:domain_plural");
    return withBreadCrumbs(
      { to: baseUrl, children: title },
      <>
        <Switch>
          <Route exact={true} path={baseUrl} component={Index} />
          <Route path={baseUrl + "/create/:id"} component={Clone} />
          <Route path={baseUrl + "/create"} component={Create} />
          <Route path={baseUrl + "/:id"} component={Show} />
        </Switch>
      </>
    );
  }
};

const injectDataSource = (comp: any) =>
  inject("serviceProfile", "i18n")(observer(comp));

const IndexViewColumns = ServiceProfileSchema.extend<DynamicColumn>(
  {
    name: {}
  },
  {
    onlyGiven: true
  }
);
export const Index = injectDataSource(
  ({ serviceProfile, i18n, ...rest }: any) => {
    const title = i18n.t("hns:serviceProfile:domain", { count: 2 });
    return (
      <IndexView
        dataSource={serviceProfile.listDataSource}
        {...rest}
        title={title}
        columns={IndexViewColumns}
        rowButtons={{ edit: true, delete: true, copy: true, export: true }}
        toolbarButtons={{ delete: true, export: true }}
      />
    );
  }
);

export const Create = injectDataSource(
  ({ serviceProfile, i18n, match, ...rest }: any) => {
    const title = i18n.t("common:create", {
      domain: "hns:serviceProfile:domain"
    });
    const history = useHistory();
    return withBreadCrumbs(
      { to: match.url + "/edit", children: title },
      <CreateView
        dataSource={serviceProfile.oneDataSource}
        {...rest}
        title={title}
        initialValues={DEFAULT_SERVICE_PROFILE}
        fields={ServiceProfileSchema}
        id={match.params}
        goBack={() => history.goBack()}
      />
    );
  }
);

export const Clone = injectDataSource(
  ({ serviceProfile, i18n, match, ...rest }: any) => {
    const title = i18n.t("common:create", {
      domain: "hns:serviceProfile:domain"
    });
    const history = useHistory();
    return withBreadCrumbs(
      { to: match.url + "/edit", children: title },
      <CreateView
        dataSource={serviceProfile.oneDataSource}
        {...rest}
        title={title}
        fields={ServiceProfileSchema}
        id={match.params}
        goBack={() => history.goBack()}
      />
    );
  }
);

export const Show = injectDataSource(({ serviceProfile, i18n, match }: any) => {
  const title = i18n.t("common:edit", { domain: "hns:serviceProfile:domain" });
  const history = useHistory();
  return withBreadCrumbs(
    { to: match.url + "/edit", children: title },
    <ShowView
      dataSource={serviceProfile.oneDataSource}
      title={title}
      fields={ServiceProfileSchema}
      id={match.params}
      goBack={() => history.goBack()}
    />
  );
});
